import { render, staticRenderFns } from "./AutoInspection.vue?vue&type=template&id=318f52d2"
import script from "./AutoInspection.vue?vue&type=script&lang=js"
export * from "./AutoInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports